const customerValidation = (formData) => {
    let newErrors = {};

    // --- First Name Validation ---
    if (!formData.firstName.trim()) {
        newErrors.firstName = 'First Name is required.';
    } else if (formData.firstName.trim().length > 25) { // Max 25 characters
        newErrors.firstName = 'First Name cannot exceed 25 characters.';
    } else if (formData.firstName.trim().length < 2) { // Min 2 characters (from SP)
        newErrors.firstName = 'First Name must be at least 2 characters long.';
    }

    // --- Last Name Validation ---
    if (!formData.lastName.trim()) {
        newErrors.lastName = 'Last Name is required.';
    } else if (formData.lastName.trim().length > 25) { // Max 25 characters
        newErrors.lastName = 'Last Name cannot exceed 25 characters.';
    } else if (formData.lastName.trim().length < 2) { // Min 2 characters (from SP)
        newErrors.lastName = 'Last Name must be at least 2 characters long.';
    }

    // --- Email Validation ---
    if (!formData.email.trim()) {
        newErrors.email = 'Email address is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = 'Email address is invalid.';
    } else if (formData.email.trim().length > 50) { // Max 50 characters
        newErrors.email = 'Email address cannot exceed 50 characters.';
    } else if (formData.email.trim().length < 5) { // Min 5 characters (from SP)
        newErrors.email = 'Email address must be at least 5 characters long.';
    }
    // Note: Email uniqueness is a backend validation.

    // --- Phone Number Validation (assuming it comes masked, so strip non-digits) ---
    const rawPhone = formData.phone.replace(/\D/g, ''); // Strip all non-digits
    if (!rawPhone) {
        newErrors.phone = 'Phone number is required.';
    } 
    
    // else if (rawPhone.length !== 10) { // Must be 10 digits
    //     newErrors.phone = 'Phone number must be 10 digits long.';
    // } else if (!/^\d+$/.test(rawPhone)) { // Ensure it's purely numeric after stripping
    //     newErrors.phone = 'Phone number must be numeric.';
    // }

    // --- Street Address Validation ---
    if (!formData.streetAddress.trim()) {
        newErrors.streetAddress = 'Street Address is required.';
    }
    // Add max length if needed, e.g., else if (formData.streetAddress.trim().length > 100) { ... }

    // --- City Validation ---
    if (!formData.city.trim()) {
        newErrors.city = 'City is required.';
    }
    // Add max length if needed, e.g., else if (formData.city.trim().length > 50) { ... }

    // --- State Validation ---
    if (!formData.state.trim()) {
        newErrors.state = 'State is required.';
    } else if (formData.state.trim().length !== 2) { // Must be 2 characters long
        newErrors.state = 'State must be 2 characters long (e.g., NY, CA).';
    } else if (!/^[A-Za-z]{2}$/.test(formData.state.trim())) { // Ensure it's 2 letters
        newErrors.state = 'State must be 2 alphabetic characters.';
    }

    // --- Zip Code Validation (assuming it comes masked, so strip non-digits) ---
    const rawZipCode = formData.zipCode.replace(/\D/g, ''); // Strip all non-digits
    if (!rawZipCode) {
        newErrors.zipCode = 'Zip code is required.';
    } else if (rawZipCode.length !== 5) { // Must be 5 characters long
        newErrors.zipCode = 'Zip code must be 5 digits long.';
    } else if (!/^\d+$/.test(rawZipCode)) { // Ensure it's purely numeric after stripping
        newErrors.zipCode = 'Zip code must be numeric.';
    }

    return newErrors;
};

export default customerValidation;
